import React from 'react'
import Scanner from './components/Scanner'

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="px-4 py-3 border-b border-edge flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-muted">Nanza</div>
          <h1 className="text-lg font-semibold">Card Scan</h1>
        </div>
        <a
          href="https://cortex.nanza.dev"
          className="text-xs text-muted hover:text-white"
          target="_blank"
          rel="noreferrer"
        >
          cortex
        </a>
      </header>
      <main className="flex-1 flex flex-col">
        <Scanner />
      </main>
    </div>
  )
}
